export const profileConstants = {
  name: 'Antonio Torres',
  job: 'iOS Developer',
  title: 'Hello World!',
  description: 'I\'m a mobile developer with solid experience building iOS apps using Swift, SwiftUI, and Objective-C, plus cross-platform projects with React Native. From México🇲🇽 and currently based in Ireland🇮🇪, I enjoy turning ideas into clean, user-focused apps and working across teams to make it happen. \n\nMy passion for tech led me to earn a Master\'s in AI for Business, where I explored how mobile and AI can work together. Now, I’m focused on building smarter, more intuitive digital experiences.',
  socialLinks: [
    { icon: 'mdi-github', url: 'https://github.com/antoniotrrs', id:'github_button' },
    { icon: 'mdi-linkedin', url: 'https://linkedin.com/in/antoniotrrs', id:'linkedin_button' },
    { icon: 'mdi-apple', url: '', id:'twitter_button' },
  ],
}
